import AbstractParticipationModel from './AbstractParticipationModel';
import doc                        from '@widesk-core/decorators/doc';
import { RenderNameProps }        from '@widesk-ui/mixins/ApiModelRenderName';
import appStore                   from '@/stores/appStore';
import { Translatable }           from '@widesk-core/decorators/translatable';
import { computed }               from 'mobx';
import EntityModel                from '@models/fondations/EntityModel';

@doc.urnResource('participation')
@doc.translatable({ title: true, excerpt: true, content: true })
class ParticipationModel extends AbstractParticipationModel {
	@doc.modelUrn(EntityModel) declare entity: EntityModel;

	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & ParticipationNameProps) {
		return super.renderName(props);
	}

	static get prefix() {
		return '/invites/';
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}${this.prefix}`;
	}

	getUrl(complete = false) {
		const path = ParticipationModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	get status() {
		return this.participationStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}
}

interface ParticipationModel
	extends Translatable<{ excerpt: true, title: true, content: true }> {
}

export default ParticipationModel;
